import ApiService from './api.service'

const TowerService = {

  /***
   * Get Towers
   * @returns {*}
   */
  get (rowkey) {
    return ApiService.get('tower', rowkey)
  },

  /***
   * Get Tower Access Points
   * @returns {*}
   */
  getTowerAps (rowkey, params) {
    return ApiService.query(`tower/${rowkey}/ap`, params)
  },
}
export default TowerService
